import {
  Component,
  OnInit,
  inject,
  ViewChild,
  ChangeDetectorRef,
  ElementRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { NotificacaoService } from '../../../core/services/notificacao.service';
import { FirebaseMessagingService } from '../../../core/services/firebase-messaging.service';
import { ToastService } from '../../../core/services/toast.service';
import { Notificacao } from '../../../core/models/notificacao.model';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from '../button/button.module';
import { OverlayBadgeComponent } from '../badge/overlay-badge/overlay-badge.component';
import { PopoverComponent } from '../panel/components/popover/popover.component';

@Component({
  selector: 'app-notificacao-badge',
  standalone: true,
  imports: [
    CommonModule,
    OverlayPanelModule,
    BadgeModule,
    ButtonModule,
    OverlayBadgeComponent,
    PopoverComponent,
  ],
  templateUrl: './notificacao-badge.component.html',
  styleUrls: ['./notificacao-badge.component.scss'],
})
export class NotificacaoBadgeComponent implements OnInit {
  @ViewChild('notifPanel') notifPanel!: PopoverComponent;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;

  private notificacaoService = inject(NotificacaoService);
  private firebaseService = inject(FirebaseMessagingService);
  private toastService = inject(ToastService);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);

  notificacoes: Notificacao[] = [];
  totalNaoLidas = 0;
  carregando = false;
  pushHabilitado = false;
  paginaAtual = 1;
  btnCarregarMais = true;

  ngOnInit(): void {
    this.firebaseService.permissionStatus$.subscribe(hasPermission => {
      this.pushHabilitado = hasPermission;
      this.cdr.markForCheck();
    });

    this.notificacaoService.totalNaoLidas$.subscribe(total => {
      this.totalNaoLidas = total;
      this.cdr.markForCheck();
    });

    this.firebaseService.message$.subscribe(() => {
      this.notificacaoService.atualizarTotalNaoLidas();
      this.atualizarNotificacoes();
    });

    this.carregarNotificacoes();
  }

  togglePanel(event: Event): void {
    this.notifPanel.abrir(event);
  }

  carregarNotificacoes(done?: () => void): void {
    this.carregando = true;

    this.notificacaoService.listar(this.paginaAtual).subscribe({
      next: response => {
        if (this.paginaAtual === 1) {
          this.notificacoes = response.notificacoes;
        } else {
          this.notificacoes.push(...response.notificacoes);
        }

        this.totalNaoLidas = response.totalNaoLidas;
        this.btnCarregarMais = response.notificacoes.length === 10;
        this.carregando = false;

        if (done) {
          Promise.resolve().then(() => done());
        }
      },
      error: () => {
        this.toastService.showErrorToast(
          'Erro ao carregar notificações',
          'Não foi possível carregar as notificações. Tente novamente mais tarde.',
        );
        this.carregando = false;
      },
    });
  }

  carregarMaisNotificacoes(): void {
    const container = this.scrollContainer.nativeElement;
    const previousScrollTop = container.scrollTop;

    this.paginaAtual++;

    this.carregarNotificacoes(() => {
      requestAnimationFrame(() => {
        const el = this.scrollContainer.nativeElement;
        el.scrollTop = previousScrollTop;
      });
    });
  }

  atualizarNotificacoes(): void {
    this.paginaAtual = 1;
    this.carregarNotificacoes();
  }
  marcarComoLida(notificacao: Notificacao): void {
    if (!notificacao.lida) {
      this.notificacaoService.marcarComoLida(notificacao.id).subscribe({
        next: () => {
          notificacao.lida = true;
          notificacao.lidaEm = new Date();
        },
      });
    }

    if (notificacao.link) {
      this.notifPanel.fechar();
      this.router.navigateByUrl(notificacao.link);
    }
  }

  obterCorIndicador(notificacao: Notificacao): string {
    const titulo = notificacao.titulo.toLowerCase();
    if (titulo.includes('reprovad')) {
      return 'bg-red-500';
    } else if (titulo.includes('aprovad')) {
      return 'bg-green-500';
    } else if (titulo.includes('enviad')) {
      return 'bg-yellow-500';
    }
    return 'bg-blue-500';
  }

  marcarTodasComoLidas(): void {
    this.notificacaoService.marcarTodasComoLidas().subscribe({
      next: () => {
        this.notificacoes.forEach(n => {
          n.lida = true;
          n.lidaEm = new Date();
        });
        this.totalNaoLidas = 0;
      },
    });
  }

  async habilitarNotificacoes(): Promise<void> {
    try {
      await this.firebaseService.requestPermissionAndRegister();
    } catch {
      this.toastService.showErrorToast(
        'Erro ao habilitar notificações',
        'Não foi possível ativar as notificações. Verifique as permissões do navegador.',
      );
    }
  }

  formatarData(data: Date): string {
    return new Date(data).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }
}
